import { Link } from "../../components/atoms/Link";
import { Divider } from "../../components/atoms/Divider";
import { Heading } from "../../components/atoms/Heading";
export const DSLRules = [{
  token: 'link',
  component: Link,
  content: true,
  defaultProps: {
    target: '_self'
  },
  props: [{
    name: 'href',
    required: true
  }, {
    name: 'target',
    content: ['_blank', '_self', '_parent', '_top']
  }]
}, {
  token: 'hr',
  component: Divider
}, {
  token: 'h1',
  component: Heading,
  content: true,
  defaultProps: {
    h: '1'
  }
}, {
  token: 'h2',
  component: Heading,
  content: true,
  defaultProps: {
    h: '2'
  }
}, {
  token: 'h3',
  component: Heading,
  content: true,
  defaultProps: {
    h: '3'
  }
}, {
  token: 'h4',
  component: Heading,
  content: true,
  defaultProps: {
    h: '4'
  }
}, {
  token: 'h5',
  component: Heading,
  content: true,
  defaultProps: {
    h: '5'
  }
}, {
  token: 'br',
  component: 'br'
}, {
  token: 'medium',
  component: 'b',
  content: true
}, {
  token: 'bold',
  component: 'strong',
  content: true
}, {
  token: 'sup',
  component: 'sup',
  content: true
}, {
  token: 'sub',
  component: 'sub',
  content: true
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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